var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-dialog",
    { attrs: { value: _vm.dialog, "max-width": "560", persistent: "" } },
    [
      _vm.payslip
        ? _c(
            "v-card",
            [
              _c(
                "v-form",
                {
                  on: {
                    submit: function ($event) {
                      $event.preventDefault()
                      return _vm.sign.apply(null, arguments)
                    },
                  },
                },
                [
                  _c("v-card-title", [
                    _c("span", { staticClass: "headline" }, [
                      _vm._v(
                        _vm._s(
                          _vm.readonly ? "Recibo firmado" : "Firmar recibo"
                        )
                      ),
                    ]),
                  ]),
                  _c(
                    "v-card-text",
                    { staticClass: "text-left" },
                    [
                      _c("p", { staticClass: "mb-2" }, [
                        _c("b", [_vm._v(_vm._s(_vm.periodTitle(_vm.payslip)))]),
                        _vm._v(
                          " · " +
                            _vm._s(
                              _vm.payslip.type ? _vm.payslip.type.name : ""
                            ) +
                            " "
                        ),
                      ]),
                      _vm.readonly
                        ? _c("p", { staticClass: "mb-3" }, [
                            _vm._v(" Firmado el "),
                            _c("b", [
                              _vm._v(
                                _vm._s(
                                  _vm.formatDateTime(_vm.payslip.signed_at)
                                )
                              ),
                            ]),
                          ])
                        : _c(
                            "p",
                            { staticClass: "mb-3 grey--text text--darken-1" },
                            [
                              _vm._v(
                                " Si no estás de acuerdo, firmalo en disconformidad e indicá el motivo: igual queda registrado que lo recibiste. "
                              ),
                            ]
                          ),
                      _c(
                        "v-radio-group",
                        {
                          staticClass: "mt-0",
                          attrs: {
                            row: "",
                            "hide-details": "",
                            disabled: _vm.readonly,
                          },
                          model: {
                            value: _vm.conformity,
                            callback: function ($$v) {
                              _vm.conformity = $$v
                            },
                            expression: "conformity",
                          },
                        },
                        [
                          _c("v-radio", {
                            attrs: { label: "Conforme", value: _vm.agree },
                          }),
                          _c("v-radio", {
                            attrs: {
                              label: "Disconforme",
                              value: _vm.disagree,
                            },
                          }),
                        ],
                        1
                      ),
                      _vm.conformity == _vm.disagree
                        ? _c(
                            "div",
                            { staticClass: "mt-3" },
                            [
                              _c("v-textarea", {
                                directives: [
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value: _vm.readonly
                                      ? ""
                                      : "required|max:1000",
                                    expression:
                                      "readonly ? '' : 'required|max:1000'",
                                  },
                                ],
                                attrs: {
                                  label: "Motivo de la disconformidad*",
                                  name: "reason",
                                  "data-vv-as": "motivo",
                                  rows: "3",
                                  disabled: _vm.readonly,
                                },
                                model: {
                                  value: _vm.reason,
                                  callback: function ($$v) {
                                    _vm.reason = $$v
                                  },
                                  expression: "reason",
                                },
                              }),
                              _c("span", { staticClass: "red--text" }, [
                                _vm._v(_vm._s(_vm.errors.first("reason"))),
                              ]),
                            ],
                            1
                          )
                        : _vm._e(),
                      _c(
                        "div",
                        { staticClass: "mt-4" },
                        [
                          _c("v-label", { staticClass: "label-input" }, [
                            _vm._v(
                              _vm._s(_vm.readonly ? "Firma" : "Tu firma*")
                            ),
                          ]),
                          _vm.readonly
                            ? _c(
                                "div",
                                { staticClass: "signature-view mt-2" },
                                [
                                  _vm.loading_signature
                                    ? _c("v-progress-circular", {
                                        attrs: {
                                          indeterminate: "",
                                          size: "24",
                                          color: "primary",
                                        },
                                      })
                                    : _vm.signature_image
                                    ? _c("img", {
                                        attrs: {
                                          src: _vm.signature_image,
                                          alt: "Firma del empleado",
                                        },
                                      })
                                    : _c(
                                        "span",
                                        { staticClass: "grey--text" },
                                        [_vm._v("Firmado sin firma dibujada.")]
                                      ),
                                ],
                                1
                              )
                            : [
                                _c("SignaturePad", {
                                  ref: "pad",
                                  staticClass: "mt-2",
                                  attrs: { error: _vm.signature_error },
                                  model: {
                                    value: _vm.signature,
                                    callback: function ($$v) {
                                      _vm.signature = $$v
                                    },
                                    expression: "signature",
                                  },
                                }),
                                _vm.signature_error
                                  ? _c("span", { staticClass: "red--text" }, [
                                      _vm._v("Dibujá tu firma."),
                                    ])
                                  : _vm._e(),
                              ],
                        ],
                        2
                      ),
                      !_vm.readonly
                        ? _c(
                            "div",
                            { staticClass: "mt-2" },
                            [
                              _c("v-text-field", {
                                directives: [
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value: "required",
                                    expression: "'required'",
                                  },
                                ],
                                attrs: {
                                  label: "Tu contraseña*",
                                  name: "password",
                                  "data-vv-as": "contraseña",
                                  type: _vm.show ? "text" : "password",
                                  "append-icon": _vm.show
                                    ? "mdi-eye"
                                    : "mdi-eye-off",
                                  autocomplete: "current-password",
                                },
                                on: {
                                  "click:append": function ($event) {
                                    _vm.show = !_vm.show
                                  },
                                },
                                model: {
                                  value: _vm.password,
                                  callback: function ($$v) {
                                    _vm.password = $$v
                                  },
                                  expression: "password",
                                },
                              }),
                              _c("span", { staticClass: "red--text" }, [
                                _vm._v(_vm._s(_vm.errors.first("password"))),
                              ]),
                            ],
                            1
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                  _c(
                    "v-card-actions",
                    [
                      _c("v-spacer"),
                      _c(
                        "v-btn",
                        {
                          attrs: {
                            color: "error",
                            text: "",
                            disabled: _vm.loading,
                          },
                          on: { click: _vm.close },
                        },
                        [_vm._v(_vm._s(_vm.readonly ? "Cerrar" : "Cancelar"))]
                      ),
                      !_vm.readonly
                        ? _c(
                            "v-btn",
                            {
                              attrs: {
                                color: "success",
                                text: "",
                                type: "submit",
                                loading: _vm.loading,
                              },
                            },
                            [_vm._v("Firmar")]
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }